import { render, staticRenderFns } from "./internalTransferDetails.vue?vue&type=template&id=cd1b2f18&scoped=true"
import script from "./internalTransferDetails.vue?vue&type=script&lang=js"
export * from "./internalTransferDetails.vue?vue&type=script&lang=js"
import style0 from "./internalTransferDetails.vue?vue&type=style&index=0&id=cd1b2f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1b2f18",
  null
  
)

export default component.exports